"use strict";
var TravelerDetailViewConfig = (function () {
    function TravelerDetailViewConfig() {
    }
    return TravelerDetailViewConfig;
}());
exports.TravelerDetailViewConfig = TravelerDetailViewConfig;



// WEBPACK FOOTER //
// ./~/@bhtp-client-web/component/src/view-config-models/traveler-detail-view-config.model.js